<template>
  <div class="site">
    <header class="top">
      <a class="brand" href="javascript:;" @click="scrollTop">
        <img src="/brand-logo.png" alt="华锐智装云" />
        <span>华锐智装云</span>
      </a>
      <nav class="nav">
        <a href="javascript:;" @click="scrollTo('features')">产品能力</a>
        <a href="javascript:;" @click="scrollTo('products')">多端协同</a>
        <a href="javascript:;" @click="scrollTo('scenes')">适用场景</a>
      </nav>
      <div class="top-actions">
        <button class="login-btn" type="button" @click="goLogin">登录注册</button>
        <button class="consult-btn" type="button" @click="goContact">联系咨询</button>
      </div>
    </header>

    <main>
      <section class="hero">
        <div class="hero-copy">
          <p class="eyebrow">面向装饰公司的项目数字化管理平台</p>
          <h1>让装修管理<br />更清晰、更高效、更专业</h1>
          <p class="lead">
            公司、项目经理、工人和业主各看各的界面，进度、材料、人工和通知连在一起。过程留痕，责任清楚，客户也能随时了解工地进展。
          </p>
          <div class="hero-actions">
            <button class="login-btn" type="button" @click="goLogin">登录注册</button>
            <button class="ghost-btn" type="button" @click="scrollTo('products')">查看产品界面</button>
          </div>
          <ul class="hero-points">
            <li v-for="p in points" :key="p">{{ p }}</li>
          </ul>
        </div>
        <button class="hero-shot" type="button" @click="openShot(pcShot)" aria-label="查看公司管理端首页">
          <span class="window-bar" aria-hidden="true">
            <i></i><i></i><i></i>
            <em>华锐智装云 · 公司管理端</em>
          </span>
          <img :src="pcShot.src" :alt="pcShot.title" />
        </button>
      </section>

      <section id="features" class="block">
        <div class="block-head">
          <p class="eyebrow">产品能力</p>
          <h2>把项目、现场和客户服务放在一张网上</h2>
        </div>
        <div class="feature-grid">
          <article v-for="item in features" :key="item.title" class="feature">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>
      </section>

      <section class="flow">
        <div class="flow-inner">
          <div v-for="(step, i) in steps" :key="step.title" class="step">
            <span class="step-no">0{{ i + 1 }}</span>
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </div>
        </div>
      </section>

      <section id="products" class="block products">
        <div class="block-head">
          <p class="eyebrow">多端协同</p>
          <h2>同一项目，四个角色各用各的端</h2>
          <p class="block-desc">点击缩略图可放大查看。界面来自系统实际页面。</p>
        </div>
        <div class="port-tabs" role="tablist">
          <button
            v-for="port in ports"
            :key="port.id"
            type="button"
            role="tab"
            :class="{ on: port.id === activePortId }"
            :aria-selected="port.id === activePortId"
            @click="selectPort(port.id)"
          >
            <strong>{{ port.name }}</strong>
            <span>{{ port.device }}</span>
          </button>
        </div>
        <div class="showcase" v-if="activePort">
          <div class="showcase-copy">
            <h3>{{ activePort.name }}</h3>
            <p>{{ activePort.summary }}</p>
            <ul>
              <li v-for="line in activePort.points" :key="line">{{ line }}</li>
            </ul>
          </div>
          <div class="showcase-stage" :class="activePort.frame">
            <button class="stage-main" type="button" @click="openShot(activeShot)">
              <img v-if="activeShot" :src="activeShot.src" :alt="activeShot.title" />
            </button>
            <p v-if="activeShot" class="shot-caption">
              <strong>{{ activeShot.title }}</strong>
              <span>{{ activeShot.desc }}</span>
            </p>
            <div class="thumbs">
              <button
                v-for="shot in activePort.shots"
                :key="shot.src"
                type="button"
                :class="{ on: shot.src === (activeShot && activeShot.src) }"
                @click="activeShotSrc = shot.src"
              >
                <img :src="shot.src" :alt="shot.title" />
                <span>{{ shot.title }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section id="scenes" class="block">
        <div class="block-head">
          <p class="eyebrow">适用场景</p>
          <h2>从公司例会到业主确认，都能用上</h2>
        </div>
        <div class="scene-grid">
          <article v-for="scene in scenes" :key="scene.title">
            <h3>{{ scene.title }}</h3>
            <p>{{ scene.desc }}</p>
          </article>
        </div>
      </section>
    </main>

    <footer class="foot">
      <div>
        <strong>华锐智装云</strong>
        <p>面向装饰公司的项目、现场与客户服务平台</p>
      </div>
      <button class="login-btn" type="button" @click="goLogin">登录注册</button>
    </footer>
    <p class="legal">© 2026 苏州华锐信息科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备19066823号-1</a></p>

    <div v-if="lightbox" class="lightbox" @click="lightbox = null">
      <button class="lightbox-close" type="button" @click="lightbox = null">关闭</button>
      <figure @click.stop>
        <img :src="lightbox.src" :alt="lightbox.title" />
        <figcaption>{{ lightbox.title }} · {{ lightbox.desc }}</figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfficialSite',
  data() {
    const pcShot = {
      src: '/site/pc-home.png',
      title: '经营首页',
      desc: '项目概况、待办审批、施工态势和履约进度集中在一屏'
    }
    return {
      pcShot,
      lightbox: null,
      activePortId: 'pc',
      activeShotSrc: pcShot.src,
      points: ['项目进度可追踪', '材料人工可协同', '现场过程可留痕', '业主进度可查看'],
      features: [
        { title: '管理更省心', desc: '项目、材料、人工、售后放在同一套流程里，减少口头交代和散落表格。' },
        { title: '成本更可控', desc: '申请、收货、退货、付款链路清楚，项目成本可以回头核对。' },
        { title: '现场更规范', desc: '项目经理排期、签到、派工，工人确认工期，过程留在系统里。' },
        { title: '客户更放心', desc: '业主在小程序里看计划、收通知、提售后，减少反复追问。' },
        { title: '供应更高效', desc: '供应商在线处理材料申请和收退货，缩短沟通和对账时间。' },
        { title: '决策更清晰', desc: '首页汇总在建项目、延期工序和待办，例会时直接看数。' }
      ],
      steps: [
        { title: '建立项目', desc: '档案、房型、工序和成员一次建好。' },
        { title: '排定计划', desc: '按日期安排工序、人员和进场。' },
        { title: '现场协同', desc: '材料、工资、签到和通知在手机上处理。' },
        { title: '客户确认', desc: '业主查看计划并确认项目通知。' }
      ],
      scenes: [
        { title: '公司内部管理', desc: '管理层看项目数量、延期、审批积压和材料人工履约，不用再汇总多张表。' },
        { title: '工地现场作业', desc: '项目经理按日历排期、推进工序；工人查看今日工地并确认工期和工资。' },
        { title: '客户服务与展示', desc: '小程序展示公司案例，业主查看自己的项目计划、通知、成员和售后入口。' }
      ],
      ports: [
        {
          id: 'pc',
          name: '公司管理端',
          device: '电脑浏览器',
          frame: 'frame-pc',
          summary: '给公司管理层和内勤使用。项目、资料、材料、人工、客户服务和经营数据都从这里进入。',
          points: ['首页看项目概况和待办', '材料申请、收货、退货可追踪', '售后、投诉和统计分析集中处理'],
          shots: [pcShot]
        },
        {
          id: 'pm',
          name: '项目经理端',
          device: '手机 App',
          frame: 'frame-phone',
          summary: '给项目经理在工地使用。待办、排期、工序、选工人、发通知和材料工资申请都在手机上完成。',
          points: ['工作台汇总近期待办', '日历查看当天进场安排', '按工序推进计划并通知业主'],
          shots: [
            { src: '/site/pm-workbench.jpg', title: '工作台', desc: '待办、项目数和近三天事项' },
            { src: '/site/pm-schedule.jpg', title: '项目排期', desc: '按日期查看进场项目和当日安排' },
            { src: '/site/pm-plan.jpg', title: '项目计划', desc: '当前工序、计划日期、施工人员和现场操作' }
          ]
        },
        {
          id: 'worker',
          name: '工人端',
          device: '手机 App',
          frame: 'frame-phone',
          summary: '给施工人员使用。看自己的工地、排期和工资，确认工期，不用再靠群消息对进度。',
          points: ['工作台看项目和工资', '日历查看自己的排期', '在工序里确认施工安排'],
          shots: [
            { src: '/site/worker-workbench.jpg', title: '工作台', desc: '未读通知、待确认工期和工资' },
            { src: '/site/worker-schedule.jpg', title: '项目排期', desc: '查看自己参与的当日安排' },
            { src: '/site/worker-plan.jpg', title: '项目计划', desc: '查看工序并确认施工安排' }
          ]
        },
        {
          id: 'mp',
          name: '业主小程序',
          device: '微信小程序',
          frame: 'frame-phone',
          summary: '给业主使用。看公司案例，绑定后查看自己的项目计划、现场照片、通知和售后。',
          points: ['首页展示公司服务与案例', '项目里查看计划和成员', '收到通知后可以确认'],
          shots: [
            { src: '/site/mp-home.jpg', title: '公司首页', desc: '活动与服务案例展示' },
            { src: '/site/mp-plan.jpg', title: '项目计划', desc: '业主查看工序、日期和施工人员' },
            { src: '/site/mp-notice.jpg', title: '项目通知', desc: '开工和工序通知，业主确认后留痕' },
            { src: '/site/mp-mine.jpg', title: '我的', desc: '项目、通知、评价、售后和投诉建议' }
          ]
        }
      ]
    }
  },
  computed: {
    activePort() {
      return this.ports.find(p => p.id === this.activePortId) || this.ports[0]
    },
    activeShot() {
      const shots = (this.activePort && this.activePort.shots) || []
      return shots.find(s => s.src === this.activeShotSrc) || shots[0] || null
    }
  },
  mounted() {
    document.title = '华锐智装云'
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    goContact() {
      this.$router.push('/contact')
    },
    scrollTop() {
      const el = this.$el
      if (el) el.scrollTop = 0
    },
    scrollTo(id) {
      const node = this.$el.querySelector('#' + id)
      if (node && node.scrollIntoView) node.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    selectPort(id) {
      this.activePortId = id
      const port = this.ports.find(p => p.id === id)
      this.activeShotSrc = port && port.shots[0] ? port.shots[0].src : ''
    },
    openShot(shot) {
      if (shot) this.lightbox = shot
    }
  }
}
</script>

<style scoped>
.site {
  height: 100%;
  overflow: auto;
  background:
    radial-gradient(900px 420px at 8% -10%, rgba(37, 99, 235, 0.14), transparent 60%),
    radial-gradient(700px 360px at 100% 0%, rgba(14, 165, 233, 0.12), transparent 55%),
    #f6f8fb;
  color: #0f172a;
}
.top {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 28px;
  height: 68px;
  padding: 0 40px;
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
  backdrop-filter: blur(12px);
}
.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  letter-spacing: 0.02em;
}
.brand img {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  object-fit: contain;
  background: #fff;
}
.nav {
  display: flex;
  gap: 22px;
  margin-left: 12px;
}
.nav a {
  color: #475569;
  font-size: 14px;
  text-decoration: none;
}
.nav a:hover { color: #1d4ed8; }
.top-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.top .login-btn {
  flex-shrink: 0;
  height: 38px;
  padding: 0 18px;
  border: none;
  border-radius: 999px;
  background: #1d4ed8;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.consult-btn {
  flex-shrink: 0;
  height: 38px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid #1d4ed8;
  background: #fff;
  color: #1d4ed8;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.consult-btn:hover { background: #eff6ff; }
.top .login-btn:hover,
.hero-actions .login-btn:hover,
.foot .login-btn:hover { background: #1e40af; }
.ghost-btn {
  height: 44px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #0f172a;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.ghost-btn:hover { border-color: #93c5fd; color: #1d4ed8; }
.hero {
  display: grid;
  grid-template-columns: minmax(320px, 0.86fr) minmax(420px, 1.14fr);
  gap: 48px;
  align-items: center;
  max-width: 1180px;
  margin: 0 auto;
  padding: 64px 40px 36px;
}
.eyebrow {
  margin: 0 0 14px;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.hero .eyebrow {
  font-size: 16px;
  letter-spacing: 0.04em;
}
.hero h1 {
  margin: 0;
  font-size: 44px;
  line-height: 1.25;
  font-weight: 800;
  letter-spacing: -0.02em;
}
.lead {
  margin: 18px 0 0;
  max-width: 520px;
  color: #475569;
  font-size: 16px;
  line-height: 1.75;
}
.hero-actions {
  display: flex;
  gap: 12px;
  margin-top: 28px;
}
.hero-actions .login-btn,
.foot .login-btn {
  margin-left: 0;
  height: 44px;
  padding: 0 22px;
  border: none;
  border-radius: 999px;
  background: #1d4ed8;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.hero-points {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 28px 0 0;
  padding: 0;
  list-style: none;
}
.hero-points li {
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #e2e8f0;
  color: #334155;
  font-size: 13px;
}
.hero-shot {
  display: block;
  width: 100%;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.1);
  overflow: hidden;
  cursor: zoom-in;
  text-align: left;
}
.window-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.window-bar i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
}
.window-bar em {
  margin-left: 8px;
  color: #94a3b8;
  font-size: 12px;
  font-style: normal;
}
.hero-shot img {
  display: block;
  width: 100%;
  height: auto;
}
.block {
  max-width: 1180px;
  margin: 0 auto;
  padding: 56px 40px;
}
.block-head h2 {
  margin: 0;
  font-size: 32px;
  line-height: 1.3;
}
.block-desc {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 14px;
}
.feature-grid,
.scene-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-top: 28px;
}
.feature,
.scene-grid article {
  padding: 22px 22px 20px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid #e7eef6;
}
.feature h3,
.scene-grid h3 {
  margin: 0 0 8px;
  font-size: 17px;
}
.feature p,
.scene-grid p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}
.flow {
  background: #0f172a;
  color: #fff;
}
.flow-inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 36px 40px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
}
.step-no {
  color: #93c5fd;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.step h3 { margin: 8px 0 6px; font-size: 18px; }
.step p { margin: 0; color: #cbd5e1; font-size: 14px; line-height: 1.6; }
.port-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 28px;
}
.port-tabs button {
  padding: 16px 16px 14px;
  text-align: left;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
}
.port-tabs button strong { display: block; font-size: 16px; color: #0f172a; }
.port-tabs button span { display: block; margin-top: 4px; color: #94a3b8; font-size: 12px; }
.port-tabs button.on {
  border-color: #1d4ed8;
  background: #eff6ff;
  box-shadow: inset 0 0 0 1px #1d4ed8;
}
.showcase {
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr);
  gap: 28px;
  margin-top: 22px;
  padding: 24px;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #e7eef6;
}
.showcase-copy h3 { margin: 8px 0 10px; font-size: 24px; }
.showcase-copy p { margin: 0; color: #475569; line-height: 1.7; }
.showcase-copy ul { margin: 16px 0 0; padding-left: 18px; color: #334155; }
.showcase-copy li { margin: 8px 0; line-height: 1.5; }
.stage-main {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: #f8fafc;
  border-radius: 16px;
  overflow: hidden;
  cursor: zoom-in;
}
.frame-phone .stage-main {
  width: min(280px, 100%);
  margin: 0 auto;
  border-radius: 28px;
  border: 8px solid #0f172a;
  background: #0f172a;
}
.stage-main img { display: block; width: 100%; height: auto; }
.shot-caption {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 14px 0 0;
  text-align: center;
}
.shot-caption strong { font-size: 15px; }
.shot-caption span { color: #64748b; font-size: 13px; }
.thumbs {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
}
.thumbs button {
  width: 92px;
  padding: 6px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
}
.thumbs button.on { border-color: #1d4ed8; }
.thumbs img {
  display: block;
  width: 100%;
  height: 64px;
  object-fit: cover;
  object-position: top;
  border-radius: 6px;
  background: #f8fafc;
}
.thumbs span {
  display: block;
  margin-top: 4px;
  color: #475569;
  font-size: 12px;
}
.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: 1180px;
  margin: 0 auto;
  padding: 28px 40px 40px;
  color: #64748b;
}
.foot strong { color: #0f172a; font-size: 16px; }
.foot p { margin: 6px 0 0; font-size: 13px; }
.foot .login-btn { margin-left: 0; }
.legal {
  margin: 0;
  padding: 18px 24px 28px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.6;
}
.legal a { color: #64748b; text-decoration: none; }
.legal a:hover { color: #1d4ed8; }
.lightbox {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(15, 23, 42, 0.72);
}
.lightbox figure {
  margin: 0;
  max-width: min(1100px, 100%);
  max-height: 100%;
}
.lightbox img {
  display: block;
  max-width: 100%;
  max-height: calc(100vh - 120px);
  margin: 0 auto;
  border-radius: 12px;
  background: #fff;
}
.lightbox figcaption {
  margin-top: 10px;
  color: #e2e8f0;
  text-align: center;
  font-size: 14px;
}
.lightbox-close {
  position: absolute;
  top: 18px;
  right: 18px;
  height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 999px;
  background: #fff;
  cursor: pointer;
}
@media (max-width: 980px) {
  .hero,
  .showcase,
  .feature-grid,
  .scene-grid,
  .flow-inner,
  .port-tabs {
    grid-template-columns: 1fr 1fr;
  }
  .hero { padding-top: 36px; }
  .hero h1 { font-size: 34px; }
  .nav { display: none; }
}
@media (max-width: 720px) {
  .top { padding: 0 16px; }
  .top-actions {
    position: fixed;
    top: 14px;
    right: 12px;
    z-index: 30;
    margin-left: 0;
    gap: 8px;
  }
  .top .login-btn,
  .consult-btn {
    height: 34px;
    padding: 0 12px;
    font-size: 13px;
  }
  .hero,
  .block,
  .flow-inner,
  .foot { padding-left: 16px; padding-right: 16px; }
  .hero,
  .showcase,
  .feature-grid,
  .scene-grid,
  .flow-inner,
  .port-tabs { grid-template-columns: 1fr; }
  .hero h1 { font-size: 28px; }
  .foot { flex-direction: column; align-items: flex-start; }
}
</style>
